module.exports = __webpack_public_path__ + "static/img/qr-mask.74bd325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-mask.png
// module id = 342
// module chunks = 7